/**
* How It Works JS
* -----------------------------------------------------------------------------
*
* All the JS for the How It Works component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'how-it-works',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const splide = new Splide( $( '.how-it-works__splide' )[0], {
        type: 'fade',
        arrows: false,
        pagination: false,
        rewind: true,
        speed: 400,
      } );

      splide.mount( );

      const time = 1;
      let tick;
      let height = 0;
      let isPaused = false;
      let isFirstIteration = true;

      $( '.section-jump-link' ).each( function( index ) {
        $( this ).on( 'click', function() {
          if ( !isPaused ) {
            isPaused = true;
          }

          $( `.progress-bar-${index}` ).css( {
            height: '100%',
          } );

          splide.go( index );
        } );
      } );

      function resetProgress( index ) {
        height = 0;
        const progressBar = `.progress-bar-${index}`;

        $( progressBar ).css( {
          height: '0%',
        } );

        clearInterval( tick );
      }

      function startProgressBar() {
        resetProgress( splide.index );

        if ( !isFirstIteration ) {
          splide.go( '+${i}' );
        }

        tick = setInterval( interval, 10 );
        isFirstIteration = false;
      }

      function interval( ) {
        if ( isPaused ) {
          clearInterval( tick );

          return;
        }

        const progressBar = `.progress-bar-${splide.index}`;

        height += 1 / ( time + 5 );

        if ( height>= 100 ) {
          startProgressBar();
        } else {
          $( progressBar ).css( {
            height: `${height}%`,
          } );
        }
      }

      startProgressBar();

      splide.on( 'moved', function( index, prevIndex ) {
        $( `.section-jump-link-${index}` ).addClass( 'is-active' );
        $( `.section-jump-link-${prevIndex}` ).removeClass( 'is-active' );

        if ( isPaused ) {
          $( `.progress-bar-${index}` ).css( {
            height: '100%',
          } );

          $( `.progress-bar-${prevIndex}` ).css( {
            height: 0,
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'how-it-works', COMPONENT );
} )( app );
